(function () {
  if (customElements.get('size-calculator')) return;

  var CM_PER_IN = 2.54;

  function cmToIn(cm) {
    return cm / CM_PER_IN;
  }

  function inToCm(inches) {
    return inches * CM_PER_IN;
  }

  function formatSize(n) {
    return String(n);
  }

  var WIDTH_ICONS = {
    narrow: '<svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M10 2C7 2 6 6 6 10C6 14 7 18 10 18C13 18 14 14 14 10C14 6 13 2 10 2Z" stroke="currentColor" stroke-width="1.2"/></svg>',
    standard: '<svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M10 2C6 2 4 6 4 10C4 14 6 18 10 18C14 18 16 14 16 10C16 6 14 2 10 2Z" stroke="currentColor" stroke-width="1.2"/></svg>',
    wide: '<svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M10 2C5 2 2 6 2 10C2 14 5 18 10 18C15 18 18 14 18 10C18 6 15 2 10 2Z" stroke="currentColor" stroke-width="1.2"/></svg>'
  };

  var INSTEP_ICONS = {
    low: '<svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M2 14C6 14 6 9 10 9C14 9 14 14 18 14" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"/></svg>',
    standard: '<svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M2 14C6 14 6 7 10 7C14 7 14 14 18 14" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"/></svg>',
    high: '<svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M2 14C6 14 6 4 10 4C14 4 14 14 18 14" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"/></svg>'
  };

  class SizeCalculatorElement extends HTMLElement {
    connectedCallback() {
      this.stepEls = Array.from(this.querySelectorAll('[data-sc-step]'));
      this.progressFill = this.querySelector('[data-sc-progress-fill]');
      this.progressText = this.querySelector('[data-sc-progress-text]');
      this.stepTitleEl = this.querySelector('[data-sc-step-title]');
      this.backBtn = this.querySelector('[data-sc-back]');
      this.continueBtn = this.querySelector('[data-sc-continue]');
      this.footerEl = this.querySelector('[data-sc-footer]');
      this.lengthInput = this.querySelector('[data-sc-length-input]');
      this.lengthSlider = this.querySelector('[data-sc-length-slider]');
      this.lengthUnitLabel = this.querySelector('[data-sc-length-unit]');
      this.rangeMinLabel = this.querySelector('[data-sc-range-min]');
      this.rangeMaxLabel = this.querySelector('[data-sc-range-max]');

      this.chart = JSON.parse(this.querySelector('[data-sc-chart]').textContent);
      this.variants = JSON.parse(this.querySelector('[data-sc-variants]').textContent);
      this.optionNames = JSON.parse(this.querySelector('[data-sc-options]').textContent);
      this.fitNoteHtml = (this.querySelector('[data-sc-fit-note]') || {}).innerHTML || '';
      this.requiresSizeUp = this.hasAttribute('data-sc-size-up');

      this.sizeOptionIndex = this.optionNames.findIndex(function (n) {
        return /size/i.test(n);
      });
      this.colorOptionIndex = this.optionNames.findIndex(function (n) {
        return /colou?r/i.test(n);
      });

      this.state = {
        step: 0,
        unit: 'in',
        lengthCm: null,
        width: null,
        instep: null,
        result: null
      };

      this.titles = [
        'Find Your Perfect Fit',
        'What is your foot length?',
        'How would you describe your foot width?',
        'How would you describe your instep?',
        'Your URBNKICKS size'
      ];

      this.bindEvents();
      this.buildWidthAndInstepOptions();
      this.setUnit('in');
      this.updateLengthRange();
      this.render();
    }

    bindEvents() {
      var self = this;
      this.backBtn.addEventListener('click', function () {
        self.goTo(self.state.step - 1);
      });
      this.continueBtn.addEventListener('click', function () {
        self.handleContinue();
      });

      this.querySelectorAll('[data-sc-unit]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          self.setUnit(btn.getAttribute('data-sc-unit'));
          self.render();
        });
      });

      this.lengthInput.addEventListener('input', function () {
        var val = parseFloat(self.lengthInput.value);
        if (isNaN(val)) return;
        self.setLengthFromDisplayValue(val);
        self.syncSliderFromState();
        self.updateContinueEnabled();
      });
      this.lengthSlider.addEventListener('input', function () {
        var val = parseFloat(self.lengthSlider.value);
        self.setLengthFromDisplayValue(val);
        self.syncInputFromState();
        self.updateContinueEnabled();
      });

      var restartBtn = this.querySelector('[data-sc-restart]');
      if (restartBtn) {
        restartBtn.addEventListener('click', function () {
          self.restart();
        });
      }
    }

    buildWidthAndInstepOptions() {
      var self = this;
      this.querySelectorAll('[data-sc-choice="width"]').forEach(function (card) {
        card.innerHTML =
          '<span class="sizecalc-choice-icon">' + WIDTH_ICONS[card.getAttribute('data-value')] + '</span>' +
          card.innerHTML;
        card.addEventListener('click', function () {
          self.state.width = card.getAttribute('data-value');
          self.markChoiceSelected('width', self.state.width);
          self.updateContinueEnabled();
        });
      });
      this.querySelectorAll('[data-sc-choice="instep"]').forEach(function (card) {
        card.innerHTML =
          '<span class="sizecalc-choice-icon">' + INSTEP_ICONS[card.getAttribute('data-value')] + '</span>' +
          card.innerHTML;
        card.addEventListener('click', function () {
          self.state.instep = card.getAttribute('data-value');
          self.markChoiceSelected('instep', self.state.instep);
          self.updateContinueEnabled();
        });
      });
    }

    markChoiceSelected(group, value) {
      this.querySelectorAll('[data-sc-choice="' + group + '"]').forEach(function (card) {
        var selected = card.getAttribute('data-value') === value;
        card.setAttribute('aria-pressed', selected ? 'true' : 'false');
      });
    }

    setUnit(unit) {
      this.state.unit = unit;
      this.querySelectorAll('[data-sc-unit]').forEach(function (btn) {
        btn.setAttribute('aria-pressed', btn.getAttribute('data-sc-unit') === unit ? 'true' : 'false');
      });
      this.lengthUnitLabel.textContent = unit === 'in' ? 'IN' : 'CM';
      this.updateLengthRange();
      this.syncInputFromState();
      this.syncSliderFromState();
    }

    updateLengthRange() {
      var minCm = this.chart[0].cm;
      var maxCm = this.chart[this.chart.length - 1].cm;
      if (this.state.unit === 'in') {
        var minIn = Math.round(cmToIn(minCm) * 10) / 10;
        var maxIn = Math.round(cmToIn(maxCm) * 10) / 10;
        this.lengthSlider.min = minIn;
        this.lengthSlider.max = maxIn;
        this.lengthSlider.step = 0.05;
        this.rangeMinLabel.textContent = minIn.toFixed(1) + ' in';
        this.rangeMaxLabel.textContent = maxIn.toFixed(1) + ' in';
      } else {
        this.lengthSlider.min = minCm;
        this.lengthSlider.max = maxCm;
        this.lengthSlider.step = 0.1;
        this.rangeMinLabel.textContent = minCm.toFixed(1) + ' cm';
        this.rangeMaxLabel.textContent = maxCm.toFixed(1) + ' cm';
      }
    }

    setLengthFromDisplayValue(displayVal) {
      this.state.lengthCm = this.state.unit === 'in' ? inToCm(displayVal) : displayVal;
    }

    displayValueFromState() {
      if (this.state.lengthCm == null) return '';
      var v = this.state.unit === 'in' ? cmToIn(this.state.lengthCm) : this.state.lengthCm;
      return Math.round(v * 100) / 100;
    }

    syncInputFromState() {
      this.lengthInput.value = this.state.lengthCm == null ? '' : this.displayValueFromState();
    }

    syncSliderFromState() {
      if (this.state.lengthCm == null) return;
      var v = this.state.unit === 'in' ? cmToIn(this.state.lengthCm) : this.state.lengthCm;
      this.lengthSlider.value = v;
    }

    restart() {
      this.state = { step: 0, unit: this.state.unit, lengthCm: null, width: null, instep: null, result: null };
      this.lengthInput.value = '';
      this.lengthSlider.value = this.lengthSlider.min;
      this.querySelectorAll('[data-sc-choice]').forEach(function (card) {
        card.setAttribute('aria-pressed', 'false');
      });
      this.render();
    }

    goTo(step) {
      this.state.step = Math.max(0, Math.min(4, step));
      this.render();
    }

    isStepValid(step) {
      if (step === 0) return !!this.state.unit;
      if (step === 1) return this.state.lengthCm != null && !isNaN(this.state.lengthCm);
      if (step === 2) return !!this.state.width;
      if (step === 3) return !!this.state.instep;
      return true;
    }

    updateContinueEnabled() {
      this.continueBtn.disabled = !this.isStepValid(this.state.step);
    }

    handleContinue() {
      if (!this.isStepValid(this.state.step)) return;
      if (this.state.step === 3) {
        this.computeResult();
        this.state.step = 4;
        this.render();
        return;
      }
      this.state.step += 1;
      this.render();
    }

    lookupChartRow(cm) {
      var rows = this.chart;
      for (var i = 0; i < rows.length; i++) {
        if (cm <= rows[i].cm + 1e-6) return rows[i];
      }
      return rows[rows.length - 1];
    }

    variantOptionValue(variant, index) {
      return variant['option' + (index + 1)];
    }

    getCurrentColor() {
      if (this.colorOptionIndex === -1) return null;
      var checked = document.querySelector('variant-radios input[type="radio"]:checked, .color-swatches-box input[type="radio"]:checked');
      if (checked) return checked.value;
      var select = document.querySelector('select[name="Color"], select[name="Colour"]');
      if (select) return select.value;
      return null;
    }

    findVariantForSize(usSize) {
      var self = this;
      var color = this.getCurrentColor();
      var target = String(usSize);
      var match = this.variants.filter(function (v) {
        var sizeVal = self.sizeOptionIndex === -1 ? null : self.variantOptionValue(v, self.sizeOptionIndex);
        if (sizeVal !== target) return false;
        if (color && self.colorOptionIndex !== -1) {
          return self.variantOptionValue(v, self.colorOptionIndex) === color;
        }
        return true;
      });
      return match[0] || null;
    }

    // Product-level existence check (not stock/availability) — used before ever
    // recommending a half-size up, per the "never invent a size" requirement.
    productHasSize(usSize) {
      if (this.sizeOptionIndex === -1) return false;
      var target = String(usSize);
      var self = this;
      return this.variants.some(function (v) {
        return self.variantOptionValue(v, self.sizeOptionIndex) === target;
      });
    }

    // Fit-volume adjustment: Width + Instep can nudge the recommendation by at
    // most +0.5 US size (only for Wide + High), never more, and never onto a
    // size the product doesn't actually offer. This is intentionally separate
    // from any future product-specific "runs small / true to size" adjustment
    // (which will come from a product metafield later) so that logic can be
    // layered in without touching this method's shape.
    computeFitAdjustment(baseRow) {
      var width = this.state.width;
      var instep = this.state.instep;
      var baseUs = baseRow.us;

      if (width === 'wide' && instep === 'high') {
        var targetUs = baseUs + 0.5;
        if (this.productHasSize(targetUs)) {
          return {
            recommendedUs: targetUs,
            note: 'You selected a wide foot and high instep. We recommend going half a size up for a more comfortable fit.'
          };
        }
        return {
          recommendedUs: baseUs,
          note: 'Your measurements indicate a US ' + formatSize(baseUs) + '. Because you selected a wide foot and high instep, you may prefer a roomier fit. This style does not offer a US ' + formatSize(targetUs) + '.'
        };
      }

      if (width === 'wide') {
        return {
          recommendedUs: baseUs,
          note: 'You selected a wide foot. If you prefer extra room, consider the fit of this style when choosing your size.'
        };
      }

      if (instep === 'high') {
        return {
          recommendedUs: baseUs,
          note: 'You selected a high instep. If you prefer extra room over the top of the foot, consider the fit of this style when choosing your size.'
        };
      }

      return {
        recommendedUs: baseUs,
        note: 'Your measurements indicate a standard fit.'
      };
    }

    computeResult() {
      var baseRow = this.lookupChartRow(this.state.lengthCm);
      var fit = this.computeFitAdjustment(baseRow);
      var recommendedUs = fit.recommendedUs;
      var resultNote = fit.note;

      // Category fit exception (Loafers / Cowboy Boots run small): adds a
      // full US size on top of whatever the existing algorithm already
      // recommends. Gender- and category-gated entirely in the Liquid
      // template (data-sc-size-up) — this method stays agnostic to what
      // "Loafers" or "Cowboy Boots" means and only ever sees one boolean.
      // Reuses the same "never recommend a size the product doesn't
      // actually offer" rule already used above for the wide+high case.
      if (this.requiresSizeUp) {
        var sizeUpTarget = recommendedUs + 1;
        if (this.productHasSize(sizeUpTarget)) {
          resultNote += ' This style tends to run small, so we recommend sizing up a full US size for the best fit.';
          recommendedUs = sizeUpTarget;
        } else {
          resultNote += ' This style tends to run small and typically fits best a full US size up, but this style does not offer a US ' + formatSize(sizeUpTarget) + '.';
        }
      }

      var variant = this.findVariantForSize(recommendedUs);
      this.state.result = {
        baseRow: baseRow,
        recommendedUs: recommendedUs,
        fitVolumeNote: resultNote,
        variant: variant
      };
      this.renderResult();
    }

    renderResult() {
      var baseRow = this.state.result.baseRow;
      var recommendedUs = this.state.result.recommendedUs;
      var variant = this.state.result.variant;
      var cm = this.state.lengthCm;
      var inches = cmToIn(cm);
      var isAdjusted = recommendedUs !== baseRow.us;

      this.querySelector('[data-sc-result-eyebrow]').textContent = isAdjusted ? 'Recommended Size' : 'Your URBNKICKS Size';
      this.querySelector('[data-sc-result-us]').textContent = 'US ' + formatSize(recommendedUs);
      this.querySelector('[data-sc-result-eu]').textContent = 'EU ' + formatSize(baseRow.eu);
      this.querySelector('[data-sc-result-uk]').textContent = 'UK ' + formatSize(baseRow.uk);

      var baseSizeNote = this.querySelector('[data-sc-base-size-note]');
      if (isAdjusted) {
        baseSizeNote.hidden = false;
        baseSizeNote.textContent = 'Base size US ' + formatSize(baseRow.us);
      } else {
        baseSizeNote.hidden = true;
        baseSizeNote.textContent = '';
      }

      this.querySelector('[data-sc-result-length]').textContent = cm.toFixed(1) + ' cm / ' + inches.toFixed(2) + ' in';
      this.querySelector('[data-sc-result-width]').textContent = this.capitalize(this.state.width);
      this.querySelector('[data-sc-result-instep]').textContent = this.capitalize(this.state.instep);

      var fitNoteWrap = this.querySelector('[data-sc-fit-note-wrap]');
      var fitNoteBody = this.querySelector('[data-sc-fit-note-body]');
      var fitNoteHtml = '<p>' + this.state.result.fitVolumeNote + '</p>';
      if (this.fitNoteHtml && this.fitNoteHtml.trim() !== '') {
        fitNoteHtml += this.fitNoteHtml;
      }
      fitNoteBody.innerHTML = fitNoteHtml;
      fitNoteWrap.hidden = false;

      var availabilityEl = this.querySelector('[data-sc-availability]');
      var selectBtn = this.querySelector('[data-sc-select-size]');
      var soldOutText = this.querySelector('[data-sc-sold-out]');
      if (variant && variant.available) {
        selectBtn.hidden = false;
        soldOutText.hidden = true;
        selectBtn.textContent = 'Select Size ' + formatSize(recommendedUs);
        selectBtn.onclick = this.selectSizeOnPdp.bind(this, recommendedUs, variant);
      } else if (variant && !variant.available) {
        selectBtn.hidden = true;
        soldOutText.hidden = false;
        soldOutText.textContent = 'Size ' + formatSize(recommendedUs) + ' is currently sold out';
      } else {
        selectBtn.hidden = true;
        soldOutText.hidden = false;
        soldOutText.textContent = 'Size ' + formatSize(recommendedUs) + ' is not available for the selected color';
      }
    }

    capitalize(str) {
      if (!str) return '';
      return str.charAt(0).toUpperCase() + str.slice(1);
    }

    selectSizeOnPdp(usSize, variant) {
      var target = String(usSize);
      var input = document.querySelector(
        'variant-radios input[type="radio"][value="' + CSS.escape(target) + '"], ' +
        '.product-variants-box input[type="radio"][value="' + CSS.escape(target) + '"]'
      );
      if (input && this.sizeOptionIndex !== -1 && input.name && new RegExp('size', 'i').test(input.name)) {
        input.checked = true;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      } else {
        var select = document.querySelector('select[name="Size"]');
        if (select) {
          select.value = target;
          select.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    }

    render() {
      var self = this;
      this.stepEls.forEach(function (el, i) {
        el.hidden = i !== self.state.step;
      });
      this.stepTitleEl.textContent = this.titles[this.state.step];
      this.progressText.textContent = Math.min(this.state.step + 1, 4) + ' / 4';
      var pct = this.state.step >= 4 ? 100 : ((this.state.step + 1) / 4) * 100;
      this.progressFill.style.width = pct + '%';
      this.backBtn.hidden = this.state.step === 0 || this.state.step === 4;
      this.footerEl.hidden = this.state.step === 4;
      this.updateContinueEnabled();
      this.continueBtn.textContent = this.state.step === 3 ? 'See My Size' : 'Continue';
    }
  }

  customElements.define('size-calculator', SizeCalculatorElement);
})();
